const configFilters = {
  R: {
    properties: [
      {
        alias: 'status',
        sequence: 5,
        name: 'Estado',
        type: {
          name: 'select',
        },
        config: {
          inline: 'true',
          size: {
            lg: '4', md: '4', sm: '6', xl: '4',
          },
        },
        params: {
          multiple: 'true',
          // TODO: revisar busqueda online
          items: {
            abierta: {
              label: 'Abierta',
              value: 'OP',
            },
            cerrada: {
              label: 'Cerrada',
              value: 'CL',
            },
            cancelada: {
              label: 'Cancelada',
              value: 'CNCL',
            },
            confirmarCierre: {
              label: 'Pte. confirmar cierre',
              value: 'FIX',
            },
            planificada: {
              label: 'Planificada',
              value: 'DEL',
            },
            rechazada: {
              label: 'Rechazada',
              value: 'RCHZ',
            },
            pendienteConfirmar: {
              label: 'Pte. implantar',
              value: 'PL_ENT',
            },
            pendienteAprobacion: {
              label: 'Pte. Aprobación',
              value: 'PEND_APRO',
            },
          },
        },
      },
      {
        alias: 'open_date',
        sequence: 10,
        name: 'Periodo de registro (inicio-fin)',
        type: {
          name: 'datetime',
        },
        config: {
          inline: 'true',
          size: {
            lg: '4', md: '4', sm: '6', xl: '4',
          },
        },
        params: {
          max: 'today',
          range: true,
          format: 'DD/MM/YYYY',
          icon: false,
        },
      },
      {
        alias: 'type',
        sequence: 20,
        name: 'Tipo',
        type: {
          name: 'select',
        },
        config: {
          inline: 'true',
          initialvalue: "['R', 'I', 'P']",
          size: {
            lg: '4', md: '4', sm: '6', xl: '4',
          },
        },
        params: {
          multiple: 'true',
          // TODO: revisar busqueda online
          items: {
            Peticiones: {
              label: 'Peticiones',
              value: 'R',
            },
            Incidencias: {
              label: 'Incidencias',
              value: 'I',
            },
            Problemas: {
              label: 'Problemas',
              value: 'P',
            },
          },
        },
      },
    ],
  },
  I: {
    properties: [
      {
        alias: 'status',
        sequence: 5,
        name: 'Estado',
        type: {
          name: 'select',
        },
        config: {
          inline: 'true',
          size: {
            lg: '4', md: '4', sm: '6', xl: '4',
          },
        },
        params: {
          multiple: 'true',
          items: {
            abierta: {
              label: 'Abierta',
              value: 'OP',
            },
            cerrada: {
              label: 'Cerrada',
              value: 'CL',
            },
            cancelada: {
              label: 'Cancelada',
              value: 'CNCL',
            },
            confirmarCierre: {
              label: 'Pte. confirmar cierre',
              value: 'FIX',
            },
            planificada: {
              label: 'Planificada',
              value: 'DEL',
            },
            rechazada: {
              label: 'Rechazada',
              value: 'RCHZ',
            },
            pendienteConfirmar: {
              label: 'Pte de implantar',
              value: 'PL_ENT',
            },
            pendienteAprobacion: {
              label: 'Pendiente Aprobación',
              value: 'PEND_APRO',
            },
          },
        },
      },
      {
        alias: 'open_date',
        sequence: 10,
        name: 'Fecha de apertura',
        type: {
          name: 'datetime',
        },
        config: {
          inline: 'true',
          size: {
            lg: '4', md: '4', sm: '6', xl: '4',
          },
        },
        params: {
          max: 'today',
          range: true,
          format: 'DD/MM/YYYY',
          icon: false,
        },
      },
      {
        alias: 'resolve_date',
        sequence: 15,
        name: 'Fecha de resolución',
        type: {
          name: 'datetime',
        },
        config: {
          inline: 'true',
          size: {
            lg: '4', md: '4', sm: '6', xl: '4',
          },
        },
        params: {
          max: 'today',
          range: true,
          format: 'DD/MM/YYYY',
          icon: false,
        },
      },
    ],
  },
  P: {
    properties: [
      {
        alias: 'status',
        sequence: 5,
        name: 'Estado',
        type: {
          name: 'select',
        },
        config: {
          inline: 'true',
          size: {
            lg: '2', md: '4', sm: '6', xl: '2',
          },
        },
        params: {
          multiple: 'true',
          items: {
            abierta: {
              label: 'Abierta',
              value: 'OP',
            },
            cerrada: {
              label: 'Cerrada',
              value: 'CL',
            },
            cancelada: {
              label: 'Cancelada',
              value: 'CNCL',
            },
            confirmarCierre: {
              label: 'Pte. confirmar cierre',
              value: 'FIX',
            },
            planificada: {
              label: 'Planificada',
              value: 'DEL',
            },
            rechazada: {
              label: 'Rechazada',
              value: 'RCHZ',
            },
            pendienteConfirmar: {
              label: 'Pte de implantar',
              value: 'PL_ENT',
            },
            pendienteAprobacion: {
              label: 'Pendiente Aprobación',
              value: 'PEND_APRO',
            },
          },
        },
      },
      {
        alias: 'priority',
        sequence: 10,
        name: 'Prioridad',
        type: {
          name: 'select',
        },
        config: {
          inline: 'true',
          size: {
            lg: '2', md: '4', sm: '6', xl: '2',
          },
        },
        params: {
          multiple: 'true',
          items: {
            abierta: {
              label: '3.- Normal',
              value: '3',
            },
            cerrada: {
              label: '2.- Alta',
              value: '2',
            },
            cancelada: {
              label: '1.- Muy Alta',
              value: '1',
            },
          },
        },
      },
      {
        alias: 'customer',
        sequence: 20,
        name: 'Usuario final afectado',
        type: {
          name: 'search',
        },
        config: {
          inline: 'true',
          size: {
            lg: '2', md: '4', sm: '6', xl: '2',
          },
        },
        params: {
          entity: 'cnt',
          fields: 'first_name,last_name,middle_name',
          match: 'first_name,last_name,middle_name',
          target: 'backend',
          lookandfeel: '#item.first_name #item.last_name #item.middle_name',
        },
      },
      {
        alias: 'open_date',
        sequence: 30,
        name: 'Fecha de apertura',
        type: {
          name: 'datetime',
        },
        config: {
          inline: 'true',
          size: {
            lg: '3', md: '4', sm: '6', xl: '3',
          },
        },
        params: {
          max: 'today',
          range: true,
          format: 'DD/MM/YYYY',
          icon: false,
        },
      },
      {
        alias: 'resolve_date',
        sequence: 40,
        name: 'Fecha de resolución',
        type: {
          name: 'datetime',
        },
        config: {
          inline: 'true',
          size: {
            lg: '3', md: '4', sm: '6', xl: '3',
          },
        },
        params: {
          max: 'today',
          range: true,
          format: 'DD/MM/YYYY',
          icon: false,
        },
      },
    ],
  },
  approvals: {
    properties: [
      {
        alias: 'open_date',
        sequence: 5,
        name: 'Fecha de apertura',
        type: {
          name: 'datetimeapprovals',
        },
        config: {
          inline: 'true',
          size: {
            lg: '3', md: '4', sm: '6', xl: '3',
          },
        },
        params: {
          range: true,
          format: 'DD/MM/YYYY',
          icon: false,
          rangeMonth: null,
        },
        dependency: {
          required: 'false',
          visibility: 'true',
        },
      },
      {
        alias: 'resolve_date',
        sequence: 15,
        name: 'Fecha de rechazo',
        type: {
          name: 'datetimeapprovals',
        },
        config: {
          inline: 'true',
          size: {
            lg: '3', md: '4', sm: '6', xl: '3',
          },
        },
        params: {
          range: true,
          format: 'DD/MM/YYYY',
          icon: false,
          rangeMonth: null,
        },
        dependency: {
          required: 'false',
          visibility: 'false',
        },
      },
      {
        alias: 'last_mod_dt',
        sequence: 25,
        name: 'Fecha de aprobación',
        type: {
          name: 'datetimeapprovals',
        },
        config: {
          inline: 'true',
          size: {
            lg: '3', md: '4', sm: '6', xl: '3',
          },
        },
        params: {
          range: true,
          format: 'DD/MM/YYYY',
          icon: false,
          rangeMonth: 3,
        },
        dependency: {
          required: 'false',
          visibility: 'false',
        },
      },
      {
        alias: 'customer',
        sequence: 30,
        name: 'Solicitante',
        type: {
          name: 'search',
        },
        config: {
          inline: 'true',
          size: {
            lg: '3', md: '4', sm: '6', xl: '3',
          },
        },
        params: {
          entity: 'cnt',
          fields: 'first_name,last_name,middle_name',
          match: 'first_name,last_name,middle_name',
          target: 'backend',
          lookandfeel: '#item.first_name #item.last_name #item.middle_name',
        },
        dependency: {
          required: 'false',
          visibility: 'true',
        },
        disableOutlined: true,
        prependIcon: true,
      },
    ],
  },
  pend: {
    properties: [
      {
        alias: 'status',
        sequence: 5,
        name: 'Estado',
        type: {
          name: 'select',
        },
        config: {
          inline: 'true',
          initialvalue: "['FIX', 'DEL', 'PEND_APRO']",
          size: {
            lg: '4', md: '4', sm: '6', xl: '6',
          },
        },
        params: {
          multiple: 'true',
          // TODO: revisar busqueda online
          items: {
            confirmarCierre: {
              label: 'Pte. confirmar cierre',
              value: 'FIX',
            },
            planificada: {
              label: 'Planificada',
              value: 'DEL',
            },
            pendienteAprobacion: {
              label: 'Pendiente Aprobación',
              value: 'PEND_APRO',
            },
          },
        },
      },
      {
        alias: 'type',
        sequence: 10,
        name: 'Tipo',
        type: {
          name: 'select',
        },
        config: {
          inline: 'true',
          initialvalue: "['R', 'I', 'P']",
          size: {
            lg: '4', md: '4', sm: '6', xl: '6',
          },
        },
        params: {
          multiple: 'true',
          // TODO: revisar busqueda online
          items: {
            confirmarCierre: {
              label: 'Peticiones',
              value: 'R',
            },
            planificada: {
              label: 'Incidencias',
              value: 'I',
            },
            pendienteAprobacion: {
              label: 'Problemas',
              value: 'P',
            },
          },
        },
      },
    ],
  },
};
export { configFilters as default };
